export type { EventPageProps } from "./EventPage";
export { EventPage } from "./EventPage";
